// @flow
import $ from 'jquery'
import _ from 'lodash'
import { connect } from 'react-redux'
import CampaignsTable from './CampaignsTable'
import * as campaignTableReducer from '../redux/ducks/campaignTable/reducers'
import type { State } from '../redux/ducks/campaignTable/reducers'
import type { Store } from '../redux/ducks'
import memoizeOne from 'memoize-one'
import type { FilterParamsType, StatisticFilter } from './types'
import getJson from '../services/getJson'

const GET_CAMPAIGNS_PATH = '/campaigns'

function mapStateToProps(state: Store, ownProps) {
  const campaignTableState = state.campaignTable
  const { filterParams } = campaignTableState
  const selectedFields = _.intersection(
    campaignTableState.headers,
    ownProps.filterProps.tableHeaders
  )
  const filteredCampaignList = _.every(filterParams, (value) => {
    return _.isEmpty(value)
  })
    ? campaignTableState.campaignList
    : filterCampaigns(campaignTableState.campaignList, filterParams)
  return {
    ...ownProps,
    ...campaignTableState,
    filteredCampaignList,
    selectedFields: selectedFields
  }
}

function mapDispatchToProps(dispatch: Function) {
  return {
    onInit: (initial: State) => {
      dispatch(campaignTableReducer.init(initial))
    },
    onChange: (diff: $Shape<State>) => {
      dispatch(campaignTableReducer.patch(diff))
    },
    onDatepickerChange: (filterParams: FilterParamsType, callback: Function) => {
      dispatch(campaignTableReducer.patch({ filterParams }))
      const data = filterData(filterParams)
      replaceWindowHistory(data, filterParams)
      sendFilterRequest(dispatch, data, filterParams, callback)
    }
  }
}

const filterCampaigns = memoizeOne(function(
  campaigns: Array<Object>,
  filterParams: FilterParamsType
) {
  let filteredCampaigns = filterByCampaignId(campaigns, filterParams.campaignId)
  filteredCampaigns = _.map(filteredCampaigns, (campaign) => {
    let filteredAudiences = filterByAudienceStatus(
      campaign.audiences,
      filterParams.audienceActivityStatus
    )
    filteredAudiences = filterByAudienceName(filteredAudiences, filterParams.audienceName)
    filteredAudiences = filterByAudienceProvider(filteredAudiences, filterParams.provider)
    filteredAudiences = fitlerByStatisticFilters(filteredAudiences, filterParams.statisticFilters)
    return { ...campaign, audiences: filteredAudiences }
  })
  return _.filter(filteredCampaigns, (campaign) => {
    return !_.isEmpty(campaign.audiences)
  })
})

const filterByCampaignId = memoizeOne(function(campaigns: Array<Object>, campaignId: string) {
  if (_.isEmpty(campaignId)) return campaigns
  return _.filter(campaigns, (campaign) => campaign.id === parseInt(campaignId))
})

const filterByAudienceStatus = memoizeOne(function(
  audiences: Array<Object>,
  audienceActivityStatus: string
) {
  if (_.isEmpty(audienceActivityStatus)) return audiences
  const activityFlag = audienceActivityStatus === 'active'
  return _.filter(audiences, (audience) => audience.checked === activityFlag)
})

const filterByAudienceName = memoizeOne(function(audiences: Array<Object>, audienceName: string) {
  if (_.isEmpty(audienceName)) return audiences
  return _.filter(audiences, (audience) =>
    audience.name.toLowerCase().includes(audienceName.toLowerCase())
  )
})

const filterByAudienceProvider = memoizeOne(function(audiences: Array<Object>, provider: string) {
  if (_.isEmpty(provider)) return audiences
  return _.filter(audiences, (audience) => audience.providers_list.includes(provider))
})

const fitlerByStatisticFilters = memoizeOne(function(
  audiences: Array<Object>,
  statisticFilters: Array<StatisticFilter>
) {
  if (_.isEmpty(statisticFilters)) return audiences
  return _.filter(audiences, (audience) => {
    return _.every(statisticFilters, (filter) => {
      switch (filter.comparison) {
        case 'less':
          return parseFloat(audience.statistics[filter.field]) < filter.value
        case 'more':
          return parseFloat(audience.statistics[filter.field]) > filter.value
        case 'equal':
          return parseFloat(audience.statistics[filter.field]) === filter.value
        default:
          return true
      }
    })
  })
})

function sendFilterRequest(
  dispatch: Function,
  data: Object,
  filterParams: FilterParamsType,
  callback: Function
) {
  getJson(GET_CAMPAIGNS_PATH, data, { async: true })
    .done((response: Object) => {
      const filteredResponse = filterCampaigns(response.campaigns, filterParams)
      dispatch(campaignTableReducer.patch({ campaignList: filteredResponse }))
    })
    .fail(() => window.alert('Internal error'))
    .always(() => callback())
}

function filterData(filterParams: FilterParamsType) {
  return {
    'search[datepicker]': filterParams.datepicker
  }
}

function replaceWindowHistory(data: Object, filterParams: FilterParamsType) {
  if (!window.history.replaceState) return

  window.history.replaceState(
    data,
    '',
    GET_CAMPAIGNS_PATH + '?' + $.param(filterData(filterParams))
  )
}

const CampaignsTableContainer = connect<Object, Object, _, _, _, _>(
  mapStateToProps,
  mapDispatchToProps
)(CampaignsTable)

export default CampaignsTableContainer
